/* FLOATIQ · JS mínimo y sin librerías (la compra funciona incluso sin JS) */
(() => {
  const $ = (s, c = document) => c.querySelector(s);
  const $$ = (s, c = document) => Array.from(c.querySelectorAll(s));
  // Safari y cualquier navegador de iPhone/iPad (todos usan WebKit)
  const ua = navigator.userAgent;
  const isWebKit = /iP(hone|ad|od)/.test(ua) || (/Safari/.test(ua) && !/Chrome|Chromium|Edg|Android|CriOS|FxiOS/.test(ua));

  /* ---------- Campaña (Black Week): solo entre sus fechas y con descuento real en el producto ---------- */
  const camp = window.fqCampaign || {};
  const campOn = !!(camp.on && camp.discount && Date.now() >= Date.parse(camp.start) && Date.now() < Date.parse(camp.end));
  if (campOn) {
    document.documentElement.dataset.fqCamp = 'on';
    $$('[data-fq-camp-text]').forEach((el) => { if (el.dataset.fqCampText) el.textContent = el.dataset.fqCampText; });
  }

  /* ---------- Acceso anticipado (22·11): quien llega desde el email de la lista ve su precio ---------- */
  // El enlace del email es /discount/CÓDIGO?redirect=/products/…?acceso=CÓDIGO: Shopify aplica el código al pagar y aquí solo se enseña el precio
  const early = window.fqEarly || {};
  const earlyCode = (() => {
    const fromUrl = new URLSearchParams(location.search).get('acceso');
    try { if (fromUrl) sessionStorage.setItem('fqAcceso', fromUrl); } catch (e) {}
    let saved = null;
    try { saved = sessionStorage.getItem('fqAcceso'); } catch (e) {}
    const cookie = (document.cookie.match(/(?:^|;\s*)discount_code=([^;]+)/) || [])[1];
    return String(fromUrl || saved || (cookie ? decodeURIComponent(cookie) : '')).toUpperCase();
  })();
  // Con ?vista=1 en la dirección se ve antes de tiempo, para revisarlo
  const earlyPreview = new URLSearchParams(location.search).has('vista');
  const earlyOn = !campOn && !!early.code && earlyCode === early.code && (earlyPreview || (Date.now() >= Date.parse(early.start) && Date.now() < Date.parse(early.end)));
  if (earlyOn) {
    $$('[data-fq-price-now]').forEach((el) => (el.innerHTML = early.price));
    $$('[data-fq-price-was]').forEach((el) => { el.hidden = false; el.innerHTML = early.was; });
    $$('[data-fq-price-compact]').forEach((box) => {
      if ($('[data-fq-price-was]', box)) return;
      const s = document.createElement('s');
      s.innerHTML = early.was;
      box.appendChild(s);
    });
    $$('[data-fq-price-badge]').forEach((el) => (el.hidden = false));
    // El pago a plazos se calcula en la tienda con el precio normal: aquí se cambia por la cuota y el total de hoy
    $$('.fq-klarna__amount, .fq-klarna-mini, .fq-klarna-plan, .fq-klarna-dialog__totals').forEach((el) => {
      el.innerHTML = el.innerHTML.split(early.cuotaWas).join(early.cuotaNow).split(early.was).join(early.price);
    });
    $$('[data-fq-price-pct]').forEach((el) => (el.textContent = early.pct));
    $$('[data-fq-price]').forEach((el) => {
      const note = document.createElement('p');
      note.className = 'fq-early';
      note.textContent = early.note;
      el.insertAdjacentElement('afterend', note);
    });
  }

  /* ---------- Cantidad ---------- */
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-fq-qty-step]');
    if (!btn) return;
    const input = $('input', btn.closest('[data-fq-qty]'));
    const min = parseInt(input.min || '1', 10);
    const max = parseInt(input.max || '99', 10);
    const next = (parseInt(input.value, 10) || 1) + parseInt(btn.dataset.fqQtyStep, 10);
    input.value = Math.min(max, Math.max(min, next));
    syncShopPay(btn.closest('[data-fq-form]'));
  });

  /* ---------- Pack de 2: pone 2 en la cantidad; se oculta al terminar la oferta ---------- */
  $$('[data-fq-pack]').forEach((pack) => {
    if (Date.now() / 1000 >= parseInt(pack.dataset.ends, 10)) pack.remove();
  });
  document.addEventListener('click', (e) => {
    const pack = e.target.closest('[data-fq-pack]');
    if (!pack) return;
    const form = $('[data-fq-main-buy] [data-fq-form]') || $('[data-fq-main-buy] form');
    const input = form && $('input[name="quantity"]', form);
    if (!input) return;
    input.value = Math.max(2, parseInt(input.value, 10) || 1);
    pack.classList.add('is-on');
    syncShopPay(form);
  });

  /* ---------- Ventanas (explicación del pago a plazos) ---------- */
  document.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-fq-dialog-open]');
    if (opener) {
      const dlg = document.getElementById(opener.dataset.fqDialogOpen);
      if (dlg && dlg.showModal) dlg.showModal();
      return;
    }
    if (e.target.closest('[data-fq-dialog-close]')) e.target.closest('dialog').close();
    else if (e.target.matches('dialog.fq-klarna-dialog')) e.target.close(); // clic en el fondo
  });

  /* ---------- Botón de Shop Pay: sigue a la variante y cantidad elegidas ---------- */
  function syncShopPay(form) {
    const btn = form && $('[data-fq-shoppay]', form);
    if (!btn) return;
    const id = $('[name="id"]', form);
    const qty = $('[name="quantity"]', form);
    if (id) btn.setAttribute('variants', `${id.value}:${Math.max(1, parseInt(qty && qty.value, 10) || 1)}`);
  }
  document.addEventListener('change', (e) => syncShopPay(e.target.closest('[data-fq-form]')));

  /* ---------- Estado "cargando" al enviar ---------- */
  document.addEventListener('submit', (e) => {
    const form = e.target.closest('[data-fq-form]');
    if (!form) return;
    const btn = $('[data-fq-submit]', form);
    if (btn) {
      btn.dataset.label = btn.dataset.label || btn.textContent;
      btn.classList.add('is-loading');
      btn.textContent = (window.fqStrings && window.fqStrings.loading) || 'Un momento… ✨';
    }
  });
  // Si el usuario vuelve atrás desde el checkout, restauramos los botones
  window.addEventListener('pageshow', () => {
    $$('[data-fq-submit].is-loading').forEach((btn) => {
      btn.classList.remove('is-loading');
      btn.textContent = btn.dataset.label;
    });
  });

  /* ---------- Galería ---------- */
  $$('[data-fq-gallery]').forEach((gallery) => {
    const track = $('[data-fq-track]', gallery);
    const slides = $$('[data-fq-slide]', gallery);
    const thumbs = $$('[data-fq-thumb]', gallery);
    if (!track || slides.length < 2) return;

    const dots = $$('.fq-gallery__dots span', gallery);
    const setActive = (i) => {
      dots.forEach((d, j) => d.classList.toggle('is-active', i === j));
      thumbs.forEach((t, j) => {
        t.classList.toggle('is-active', i === j);
        t.setAttribute('aria-selected', i === j ? 'true' : 'false');
      });
    };

    thumbs.forEach((t) =>
      t.addEventListener('click', () => {
        const i = parseInt(t.dataset.fqThumb, 10);
        track.scrollTo({ left: slides[i].offsetLeft, behavior: 'smooth' });
        setActive(i);
      })
    );

    // Vídeo de la galería: arranca solo y silenciado. Si el móvil bloquea el autoplay
    // (ahorro de batería o de datos), arranca con el primer toque, clic o desplazamiento.
    let current = 0;
    // iPhone en modo bajo consumo bloquea los vídeos con autoplay y muestra su botón de play.
    // Safari sí reproduce un MP4 dentro de <img> (como un GIF): lo usamos solo en ese caso.
    const swapToImage = (v) => {
      const src = $$('source', v).map((s) => s.src).find((u) => /\.mp4(\?|$)/i.test(u)) || v.currentSrc;
      if (!src || !/\.mp4(\?|$)/i.test(src)) return;
      const img = document.createElement('img');
      img.src = src;
      img.alt = v.getAttribute('aria-label') || '';
      img.setAttribute('data-fq-video-img', '');
      img.fqVideo = v; // para recuperarlo si el cliente toca un tono (ahí ya hay gesto y se puede reproducir)
      v.replaceWith(img);
    };
    // El vídeo ligero (data-fq-lazy-video) espera a que la página termine de cargar,
    // para no quitarle velocidad a las fotos, el precio y el botón. Si el cliente toca antes, arranca ya.
    let videoReady = document.readyState === 'complete' || !$('[data-fq-lazy-video]', gallery);
    const playCurrent = () => {
      if (!videoReady) return;
      const v = $('video', slides[current]);
      if (!v || !v.paused) return;
      v.muted = true;
      v.defaultMuted = true;
      v.playsInline = true;
      v.play().catch((err) => {
        if (isWebKit && err && err.name === 'NotAllowedError') swapToImage(v);
      });
    };

    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const video = $('video', entry.target);
          if (entry.isIntersecting && entry.intersectionRatio > 0.6) {
            current = slides.indexOf(entry.target);
            setActive(current);
            playCurrent();
          } else if (video && entry.boundingClientRect.width > 0) {
            // Solo pausamos cuando la galería ya está maquetada y la diapositiva salió de vista
            video.pause();
          }
        });
      },
      { root: track, threshold: [0.6] }
    );
    slides.forEach((s) => io.observe(s));

    const startVideo = () => { videoReady = true; playCurrent(); };
    if (videoReady) playCurrent();
    else {
      window.addEventListener('load', startVideo, { once: true });
      setTimeout(startVideo, 4000); // por si algún script externo retrasa el «load»
    }
    $$('video', gallery).forEach((v) => v.addEventListener('loadeddata', playCurrent));
    ['touchend', 'click', 'scroll', 'keydown'].forEach((ev) =>
      window.addEventListener(ev, startVideo, { passive: true, once: true })
    );
    document.addEventListener('visibilitychange', () => { if (!document.hidden) playCurrent(); });
  });

  /* ---------- Variantes (si el producto tiene varias) ---------- */
  $$('[data-fq-product-json]').forEach((info) => {
    const json = document.getElementById(info.dataset.fqProductJson);
    if (!json) return;
    const { variants } = JSON.parse(json.textContent);
    const select = $('[data-fq-variant-select]', info);
    if (!select) return;

    select.addEventListener('change', () => {
      const v = variants.find((x) => String(x.id) === select.value);
      if (!v) return;
      $$('[data-fq-variant-input]').forEach((input) => (input.value = v.id));
      $$('[data-fq-form]').forEach(syncShopPay);
      $$('[data-fq-price-now]').forEach((el) => (el.innerHTML = v.price));
      $$('[data-fq-price-was]').forEach((el) => {
        el.hidden = !v.compare;
        if (v.compare) el.innerHTML = v.compare;
      });
      $$('[data-fq-price-badge]').forEach((el) => (el.hidden = !v.pct));
      $$('[data-fq-price-pct]').forEach((el) => (el.textContent = v.pct || ''));
      $$('[data-fq-submit]').forEach((btn) => {
        btn.disabled = !v.available;
        if (!btn.dataset.label) btn.dataset.label = btn.textContent;
        btn.textContent = v.available ? btn.dataset.label : ((window.fqStrings && window.fqStrings.soldOut) || 'Agotado');
      });
    });
  });

  /* ---------- Cuenta atrás ---------- */
  $$('[data-fq-countdown]').forEach((el) => {
    const target = Date.parse(campOn && el.dataset.fqCountdownCamp ? el.dataset.fqCountdownCamp : el.dataset.fqCountdown);
    if (Number.isNaN(target)) return;
    const done = el.parentElement.querySelector('[data-fq-countdown-done]');
    const parts = { d: $('[data-d]', el), h: $('[data-h]', el), m: $('[data-m]', el), s: $('[data-s]', el) };
    const pad = (n) => String(n).padStart(2, '0');
    let timer;

    const tick = () => {
      const diff = target - Date.now();
      if (diff <= 0) {
        clearInterval(timer);
        el.hidden = true;
        if (done) done.hidden = false;
        return;
      }
      const s = Math.floor(diff / 1000);
      parts.d.textContent = pad(Math.floor(s / 86400));
      parts.h.textContent = pad(Math.floor((s % 86400) / 3600));
      parts.m.textContent = pad(Math.floor((s % 3600) / 60));
      parts.s.textContent = pad(s % 60);
    };
    tick();
    timer = setInterval(tick, 1000);
  });

  /* ---------- Selector de tonos (simulación sobre la galería) ---------- */
  $$('[data-fq-tones]').forEach((wrap) => {
    const gallery = wrap.closest('[data-fq-hero]')?.querySelector('[data-fq-gallery]');
    const btns = $$('[data-tone]', wrap);
    btns.forEach((b) =>
      b.addEventListener('click', () => {
        btns.forEach((x) => x.setAttribute('aria-checked', String(x === b)));
        if (gallery) gallery.dataset.tone = b.dataset.tone;
      })
    );
    // iPhone con ahorro de batería: el vídeo se mostraba como imagen animada; al tocar un tono
    // (hay gesto del usuario) recuperamos el <video> para poder teñirlo.
    if (gallery && isWebKit) {
      wrap.addEventListener('click', (e) => {
        if (!e.target.closest('[data-tone]')) return;
        $$('img[data-fq-video-img]', gallery).forEach((img) => {
          const v = img.fqVideo;
          if (!v) return;
          img.replaceWith(v);
          v.muted = true;
          v.play().catch(() => {});
        });
      }, true);
    }
  });

  /* ---------- Tonos en iPhone/Safari: WebKit no aplica filtros SVG a vídeos e imágenes,
     así que pintamos la misma fórmula (matriz de color + máscara de la lámpara) con WebGL ---------- */
  if (isWebKit) $$('[data-fq-gallery]').forEach((gallery) => {
    const TONES = {
      cold: [[0.3345, 0.6006, 0.0606], [0.1879, 0.7882, 0.0638], [0.203, 0.6828, 0.2249]],
      neutral: [[0.3882, 0.6129, 0.0619], [0.1752, 0.7953, 0.0595], [0.1577, 0.5304, 0.2595]],
    };
    const VS = 'attribute vec2 p;uniform vec4 crop;varying vec2 uv;'
      + 'void main(){uv=crop.xy+vec2(0.5+p.x*0.5,0.5-p.y*0.5)*crop.zw;gl_Position=vec4(p,0.0,1.0);}';
    const FS = 'precision mediump float;varying vec2 uv;uniform sampler2D tex;uniform vec3 r0;uniform vec3 r1;uniform vec3 r2;'
      + 'void main(){vec3 c=texture2D(tex,uv).rgb;vec3 t=clamp(vec3(dot(r0,c),dot(r1,c),dot(r2,c)),0.0,1.0);'
      + 'float a=clamp(4.4252*c.r+5.4304*c.g-7.8556*c.b-1.2,0.0,1.0);gl_FragColor=vec4(mix(c,t,a),1.0);}';
    const layers = new Map(); // slide -> { canvas, gl, ... }

    const makeLayer = (slide) => {
      const canvas = document.createElement('canvas');
      canvas.className = 'fq-tone-canvas';
      canvas.setAttribute('aria-hidden', 'true');
      const gl = canvas.getContext('webgl', { premultipliedAlpha: false, antialias: false });
      if (!gl) return null;
      const sh = (type, src) => { const s = gl.createShader(type); gl.shaderSource(s, src); gl.compileShader(s); return s; };
      const prog = gl.createProgram();
      gl.attachShader(prog, sh(gl.VERTEX_SHADER, VS));
      gl.attachShader(prog, sh(gl.FRAGMENT_SHADER, FS));
      gl.linkProgram(prog);
      if (!gl.getProgramParameter(prog, gl.LINK_STATUS)) return null;
      gl.useProgram(prog);
      const buf = gl.createBuffer();
      gl.bindBuffer(gl.ARRAY_BUFFER, buf);
      gl.bufferData(gl.ARRAY_BUFFER, new Float32Array([-1, -1, 1, -1, -1, 1, 1, 1]), gl.STATIC_DRAW);
      const loc = gl.getAttribLocation(prog, 'p');
      gl.enableVertexAttribArray(loc);
      gl.vertexAttribPointer(loc, 2, gl.FLOAT, false, 0, 0);
      const tex = gl.createTexture();
      gl.bindTexture(gl.TEXTURE_2D, tex);
      [gl.TEXTURE_WRAP_S, gl.TEXTURE_WRAP_T].forEach((k) => gl.texParameteri(gl.TEXTURE_2D, k, gl.CLAMP_TO_EDGE));
      gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR);
      gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.LINEAR);
      slide.appendChild(canvas);
      const u = (n) => gl.getUniformLocation(prog, n);
      return { canvas, gl, crop: u('crop'), r: [u('r0'), u('r1'), u('r2')], raf: 0 };
    };

    const draw = (slide, L, rows) => {
      const media = $('video, img', slide);
      if (!media) return false;
      const isVideo = media.tagName === 'VIDEO';
      const mw = isVideo ? media.videoWidth : media.naturalWidth;
      const mh = isVideo ? media.videoHeight : media.naturalHeight;
      if (!mw || !mh || (isVideo && media.readyState < 2)) return false;
      const box = slide.getBoundingClientRect();
      if (!box.width || !box.height) return false;
      const dpr = Math.min(window.devicePixelRatio || 1, 2);
      const w = Math.round(box.width * dpr);
      const h = Math.round(box.height * dpr);
      if (L.canvas.width !== w || L.canvas.height !== h) { L.canvas.width = w; L.canvas.height = h; }
      const { gl } = L;
      gl.viewport(0, 0, w, h);
      // Igual que object-fit: cover
      const scale = Math.max(box.width / mw, box.height / mh);
      const cw = box.width / scale / mw;
      const ch = box.height / scale / mh;
      gl.uniform4f(L.crop, (1 - cw) / 2, (1 - ch) / 2, cw, ch);
      rows.forEach((row, i) => gl.uniform3f(L.r[i], row[0], row[1], row[2]));
      try {
        gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, gl.RGBA, gl.UNSIGNED_BYTE, media);
      } catch (err) {
        return false;
      }
      gl.drawArrays(gl.TRIANGLE_STRIP, 0, 4);
      return true;
    };

    const stop = () => {
      layers.forEach((L, slide) => { cancelAnimationFrame(L.raf); slide.classList.remove('fq-gl-on'); });
    };

    const apply = () => {
      const rows = TONES[gallery.dataset.tone];
      stop();
      if (!rows) return; // cálido = imagen original
      $$('[data-fq-slide]', gallery).forEach((slide) => {
        if (!$('video, img', slide)) return;
        let L = layers.get(slide);
        if (!L) { L = makeLayer(slide); if (!L) return; layers.set(slide, L); }
        const loop = () => {
          if (draw(slide, L, rows)) slide.classList.add('fq-gl-on');
          const media = $('video, img', slide);
          // El vídeo se repinta en cada fotograma; las fotos, hasta que estén cargadas
          if (media && (media.tagName === 'VIDEO' || !slide.classList.contains('fq-gl-on'))) L.raf = requestAnimationFrame(loop);
        };
        loop();
      });
    };

    new MutationObserver(apply).observe(gallery, { attributes: true, attributeFilter: ['data-tone'] });
    window.addEventListener('resize', () => { if (TONES[gallery.dataset.tone]) apply(); });
    apply();
  });

  /* ---------- Fecha estimada de entrega (días HÁBILES: lunes a viernes, sin festivos) ---------- */
  $$('[data-fq-eta]').forEach((el) => {
    const min = parseInt(el.dataset.min, 10);
    const max = parseInt(el.dataset.max, 10);
    const out = $('[data-eta-text]', el);
    if (Number.isNaN(min) || Number.isNaN(max) || !out) return;
    const holidays = new Set((el.dataset.holidays || '').split(',').filter(Boolean));
    const pad = (n) => String(n).padStart(2, '0');
    const key = (d) => `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
    const isWorkday = (d) => d.getDay() !== 0 && d.getDay() !== 6 && !holidays.has(key(d));
    // Se empieza a contar el siguiente día hábil después de hoy
    const addWorkdays = (n) => {
      const d = new Date();
      d.setHours(12, 0, 0, 0);
      let left = n;
      while (left > 0) {
        d.setDate(d.getDate() + 1);
        if (isWorkday(d)) left--;
      }
      return d;
    };
    const fmt = new Intl.DateTimeFormat('es-ES', { weekday: 'short', day: 'numeric', month: 'short' });
    const f = (d) => fmt.format(d).replace(/\./g, '');
    const tpl = (window.fqStrings && window.fqStrings.eta) || 'Pídela hoy y recíbela entre el [min] y el [max]';
    const dMin = addWorkdays(min);
    const dMax = addWorkdays(max);
    out.innerHTML = tpl.replace('[min]', `<strong>${f(dMin)}</strong>`).replace('[max]', `<strong>${f(dMax)}</strong>`);
    // Versión en 3 pasos (ficha): pedido hoy → envío → en casa
    const d2 = $('[data-eta-d2]', el);
    if (d2) {
      const day = new Intl.DateTimeFormat('es-ES', { day: 'numeric', month: 'short' });
      const g = (d) => day.format(d).replace(/\./g, '');
      d2.textContent = dMin.getMonth() === dMax.getMonth()
        ? `${dMin.getDate()}–${g(dMax)}`
        : `${g(dMin)} – ${g(dMax)}`;
      if ('IntersectionObserver' in window) {
        const io = new IntersectionObserver((es) => {
          if (es.some((e) => e.isIntersecting)) { el.classList.add('is-in'); io.disconnect(); }
        }, { threshold: 0.4 });
        io.observe(el);
      } else el.classList.add('is-in');
    }
  });

  /* ---------- Vídeos de clientes (UGC) · carrusel con foco ---------- */
  $$('[data-fq-ugcv]').forEach((sec) => {
    const track = $('[data-fq-ugcv-track]', sec);
    const cards = $$('.fq-ugcv__card', sec);
    const prev = $('[data-fq-ugcv-prev]', sec);
    const next = $('[data-fq-ugcv-next]', sec);
    const dotsBox = $('[data-fq-ugcv-dots]', sec);
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const n = cards.length;
    if (!track || !n) return;

    sec.classList.add('is-coverflow');
    let active = 0;
    let inView = false;
    let userPaused = reduced; // con «reducir movimiento» el vídeo empieza en pausa

    // Puntos
    const dots = cards.map((_, i) => {
      const d = document.createElement('button');
      d.type = 'button';
      d.setAttribute('aria-label', `Ver vídeo ${i + 1} de ${n}`);
      d.addEventListener('click', () => go(i));
      dotsBox && dotsBox.appendChild(d);
      return d;
    });
    if (n > 1) { prev.hidden = false; next.hidden = false; }

    // Posición relativa circular: -1 = izquierda, 0 = centro, 1 = derecha…
    const offset = (i) => {
      let o = i - active;
      if (n > 2) { if (o > n / 2) o -= n; if (o < -n / 2) o += n; }
      return o;
    };

    const syncVideos = () => {
      cards.forEach((c, i) => {
        const v = $('video', c);
        if (!v) return;
        v.muted = true;
        const play = i === active && inView && !userPaused && !reduced;
        if (play) v.play().catch(() => {}); else v.pause();
        c.classList.toggle('is-paused', i === active && v.paused && !play);
      });
    };

    const layout = () => {
      cards.forEach((c, i) => {
        const o = offset(i);
        const a = Math.abs(o);
        c.style.setProperty('--o', o);
        c.style.setProperty('--sc', a === 0 ? 1 : a === 1 ? 0.8 : 0.66);
        c.style.setProperty('--op', a === 0 ? 1 : a === 1 ? 0.55 : 0);
        c.style.setProperty('--br', a === 0 ? 1 : 0.55);
        c.style.setProperty('--sa', a === 0 ? 1 : 0.7);
        c.style.setProperty('--z', 10 - a);
        c.classList.toggle('is-active', a === 0);
        c.classList.toggle('is-hidden', a > 1);
        c.setAttribute('aria-hidden', a === 0 ? 'false' : 'true');
      });
      dots.forEach((d, i) => d.classList.toggle('is-active', i === active));
      syncVideos();
    };

    const go = (i) => { active = (i + n) % n; userPaused = reduced; layout(); };
    prev.addEventListener('click', () => go(active - 1));
    next.addEventListener('click', () => go(active + 1));

    // Tocar un lateral lo trae al centro; tocar el central pausa / reanuda
    cards.forEach((c, i) => c.addEventListener('click', () => {
      if (moved) return;
      if (i !== active) return go(i);
      const v = $('video', c);
      if (!v) return;
      // El estado lo lleva el carrusel (no el vídeo), así funciona aunque el vídeo aún esté cargando
      userPaused = !userPaused;
      if (reduced) {
        if (userPaused) v.pause(); else v.play().catch(() => {});
      } else {
        syncVideos();
      }
      c.classList.toggle('is-paused', userPaused);
    }));

    // Deslizar con el dedo / ratón
    let x0 = null;
    let moved = false;
    track.addEventListener('pointerdown', (e) => { x0 = e.clientX; moved = false; });
    track.addEventListener('pointerup', (e) => {
      if (x0 === null) return;
      const dx = e.clientX - x0;
      x0 = null;
      if (Math.abs(dx) > 40) { moved = true; go(active + (dx < 0 ? 1 : -1)); setTimeout(() => (moved = false), 50); }
    });

    // Teclado
    sec.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowLeft') go(active - 1);
      if (e.key === 'ArrowRight') go(active + 1);
    });

    // Solo reproduce cuando la sección está en pantalla
    if ('IntersectionObserver' in window) {
      new IntersectionObserver((es) => { inView = es[0].isIntersecting; syncVideos(); }, { threshold: 0.35 }).observe(track);
    } else { inView = true; }

    layout();
  });

  /* ---------- Reseñas: «Leer más» y visor de fotos ---------- */
  $$('[data-fq-reviews]').forEach((sec) => {
    // «Leer más» solo si el texto está recortado
    $$('.fq-rv-card', sec).forEach((card) => {
      const text = $('[data-fq-rv-text]', card);
      const more = $('[data-fq-rv-more]', card);
      if (!text || !more) return;
      if (text.scrollHeight > text.clientHeight + 2) more.hidden = false;
      more.addEventListener('click', () => {
        const open = card.classList.toggle('is-open');
        const S = window.fqStrings || {};
        more.textContent = open ? (S.readLess || 'Leer menos') : (S.readMore || 'Leer más');
      });
    });

    // «Ver más reseñas»: muestra el siguiente bloque de tarjetas ocultas
    const more = $('[data-fq-rv-loadmore]', sec);
    if (more) {
      const step = parseInt(more.dataset.step, 10) || 6;
      const left = $('[data-fq-rv-remaining]', more);
      more.addEventListener('click', () => {
        const hidden = $$('.fq-rv-card--more', sec);
        hidden.slice(0, step).forEach((c, i) => {
          c.classList.remove('fq-rv-card--more');
          c.classList.add('is-revealed');
          c.style.animationDelay = `${i * 60}ms`;
          // Activa «Leer más» en las tarjetas que acaban de aparecer
          const t = $('[data-fq-rv-text]', c);
          const b = $('[data-fq-rv-more]', c);
          if (t && b && t.scrollHeight > t.clientHeight + 2) b.hidden = false;
        });
        const rest = $$('.fq-rv-card--more', sec).length;
        if (left) left.textContent = rest;
        if (!rest) more.closest('.fq-rv-more-wrap').hidden = true;
      });
    }

    // Visor de fotos (usa <dialog> nativo)
    const box = $('[data-fq-rv-lightbox]', sec);
    if (!box || typeof box.showModal !== 'function') return;
    let lastFocus = null;
    sec.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-fq-rv-open]');
      if (!btn) return;
      lastFocus = btn;
      $$('[data-fq-rv-fig]', box).forEach((f) => (f.hidden = f.dataset.fqRvFig !== btn.dataset.fqRvOpen));
      box.showModal();
    });
    $('[data-fq-rv-close]', box).addEventListener('click', () => box.close());
    box.addEventListener('click', (e) => { if (e.target === box) box.close(); });
    box.addEventListener('close', () => lastFocus && lastFocus.focus());
  });

  /* ---------- Barra de anuncio "HUD de misión" ---------- */
  $$('[data-fq-hud]').forEach((hud) => {
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    // Mensajes con fechas (desde/hasta, incluido) o solo de campaña: fuera los que no tocan hoy
    const day = (v) => { const [y, m, d] = v.split('-').map(Number); return new Date(y, m - 1, d).getTime(); };
    const now = Date.now();
    const msgs = $$('.fq-hud__msg', hud).filter((m) => {
      const ok = (!m.dataset.start || now >= day(m.dataset.start))
        && (!m.dataset.end || now < day(m.dataset.end) + 86400000)
        && (!('campOnly' in m.dataset) || campOn);
      if (!ok) m.remove();
      return ok;
    });
    if (!msgs.length) return;
    msgs.forEach((m, j) => {
      m.classList.toggle('is-active', j === 0);
      m.setAttribute('aria-hidden', j === 0 ? 'false' : 'true');
      const a = $('a', m);
      if (a) a.tabIndex = j === 0 ? 0 : -1;
    });
    const pauseBtn = $('[data-fq-hud-pause]', hud);
    let i = 0;
    let paused = false;
    let userPaused = false;

    const show = (next) => {
      const prev = msgs[i];
      prev.classList.remove('is-active');
      prev.classList.add('is-leaving');
      setTimeout(() => prev.classList.remove('is-leaving'), 400);
      i = next;
      msgs.forEach((m, j) => {
        m.setAttribute('aria-hidden', j === i ? 'false' : 'true');
        const a = $('a', m);
        if (a) a.tabIndex = j === i ? 0 : -1;
      });
      msgs[i].classList.add('is-active');
    };

    if (msgs.length > 1 && !reduced) {
      const interval = parseInt(hud.dataset.interval, 10) || 4500;
      setInterval(() => {
        if (!paused && !userPaused && !document.hidden) show((i + 1) % msgs.length);
      }, interval);
      hud.addEventListener('mouseenter', () => (paused = true));
      hud.addEventListener('mouseleave', () => (paused = false));
      hud.addEventListener('focusin', (e) => { if (e.target !== pauseBtn) paused = true; });
      hud.addEventListener('focusout', () => (paused = false));
      pauseBtn.addEventListener('click', () => {
        userPaused = !userPaused;
        pauseBtn.setAttribute('aria-pressed', String(userPaused));
        pauseBtn.textContent = userPaused ? 'Reanudar anuncios' : 'Pausar anuncios';
      });
    } else if (pauseBtn) {
      pauseBtn.remove();
    }

    // Cuenta atrás al 19·11 (gancho de marketing: el producto ya se vende)
    // Durante la campaña, el chip y el cronómetro pasan a la Black Week
    const target = Date.parse(campOn ? camp.end : hud.dataset.target);
    if (campOn) {
      const chip = $('[data-fq-hud-chip]', hud);
      const cta = $('[data-fq-hud-cta-label]', hud);
      if (chip && hud.dataset.campChip) chip.textContent = hud.dataset.campChip;
      if (cta && hud.dataset.campCta) cta.textContent = hud.dataset.campCta;
      hud.classList.add('is-camp');
    }
    const timer = $('[data-fq-hud-timer]', hud);
    const sr = $('[data-fq-hud-timer-sr]', hud);
    if (Number.isNaN(target) || !timer) return;
    const tD = $('.fq-hud__t-d', timer);
    const tM = $('.fq-hud__t-m', timer);
    const pad = (n) => String(n).padStart(2, '0');
    let lastMin = -1;
    let clock;

    // Pasada la fecha: fuera el cronómetro; el chip muestra "EN STOCK" (o se oculta si está vacío)
    const goLive = () => {
      clearInterval(clock);
      hud.classList.add('is-live');
      const chip = $('[data-fq-hud-chip]', hud);
      const cta = $('[data-fq-hud-cta-label]', hud);
      if (cta && hud.dataset.ctaAfter) cta.textContent = hud.dataset.ctaAfter;
      timer.hidden = true;
      if (sr) sr.textContent = '';
      if (chip && hud.dataset.labelAfter) chip.textContent = hud.dataset.labelAfter;
      else $('.fq-hud__mission', hud).hidden = true;
    };

    const tick = () => {
      const diff = target - Date.now();
      if (diff <= 0) return goLive();
      const s = Math.floor(diff / 1000);
      const d = Math.floor(s / 86400);
      const h = Math.floor((s % 86400) / 3600);
      const m = Math.floor((s % 3600) / 60);
      const sec = s % 60;
      if (reduced) {
        tD.textContent = `${d}D : ${pad(h)}H : ${pad(m)}M`;
        tM.textContent = `${d}D ${pad(h)}:${pad(m)}`;
      } else {
        tD.textContent = `${d}D : ${pad(h)}H : ${pad(m)}M : ${pad(sec)}S`;
        tM.textContent = `${d}D ${pad(h)}:${pad(m)}:${pad(sec)}`;
      }
      if (sr && m !== lastMin) {
        lastMin = m;
        sr.textContent = `Faltan ${d} días, ${h} horas y ${m} minutos para el 19 de noviembre.`;
      }
    };
    tick();
    clock = setInterval(tick, reduced ? 30000 : 1000);
  });

  /* ---------- Botón sticky en móvil ---------- */
  const sticky = $('[data-fq-sticky]');
  const mainBuy = $('[data-fq-main-buy]');
  if (sticky && mainBuy) {
    // La portada aísla sus capas (isolation), así que dentro de ella la barra quedaba por debajo de las secciones siguientes: va directa al body
    if (sticky.parentNode !== document.body) document.body.appendChild(sticky);
    const finalBtn = $('.fq-final__btn');
    const footer = $('.fq-footer');
    const watched = [mainBuy, finalBtn, footer].filter(Boolean);
    const visible = new Set();

    const update = () => {
      const show = visible.size === 0;
      sticky.classList.toggle('is-visible', show);
      sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
      $$('button, input, a, select', sticky).forEach((n) => (n.tabIndex = show ? 0 : -1));
    };

    const io = new IntersectionObserver((entries) => {
      entries.forEach((e) => {
        if (e.isIntersecting) visible.add(e.target);
        else visible.delete(e.target);
      });
      update();
    });
    watched.forEach((n) => io.observe(n));
    update();
  }
})();
